/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 22:04:55
 */
import axios from "axios";
import { Url } from "src/config";
import { addWcdHeaders } from "src/utils/wcdHeaders";


const loginApiService = {
  changePassword: async (password, userEmail) => {
    try {
      // eslint-disable-next-line
      const response = await axios.post(`${Url}/module/changePassword`, { password, userEmail });
    } catch (error) {
      console.log(error.message);
    }
  },
  decodeToken: async (token) => {
    try {
      const tokenData = { accessToken: token };
      const response = await axios.post(`${Url}/auth/decodeToken`, tokenData, {
        headers: addWcdHeaders()
      })
      return response.data
    } catch (error) {

    }
  },
  validateLink: async (token, inviteId,surveyID) => {
    try {
      // const response = await axios.get(`${Url}/customer/validatelink?inviteId=${inviteId}`, tokenData)
      const response = await axios.get(
        `${Url}/customer/validatelink?inviteId=${inviteId}&surveyID=${surveyID}`,
        {
          headers: addWcdHeaders({
            "access-token": token,
          }),
        }
      );
      return response.data.data
    } catch (error) {

    }
  },
  validateTeamLink: async (token, queueId, tenantId,inviteId,userId,surveyId) => {
    try {
      let url = `${Url}/customer/validateteamlink?queueid=${queueId}`;
      
      // Include tenantId in the URL if it's present
      if (tenantId !== null && tenantId !== undefined && tenantId !=='') {
        url += `&tenant_id=${tenantId}`;
      }
  if(inviteId&&userId){
    url += `&inviteId=${inviteId}&userId=${userId}`
  }
  if(surveyId){
    url +=`&surveyId=${surveyId}`
  }
      const response = await axios.get(
        url,
        {
          headers: addWcdHeaders({
            "access-token": token,
          }),
        }
      );
      return response.data.data;
    } catch (error) {
      // Handle error
    }
  },
  listProfiles: async (accessToken) => {
    try {
      const response = await axios.get(`${Url}/customer/listMyProfiles`, {
        headers: addWcdHeaders({
          "access-token": accessToken,
        }),
      });
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },
  getToken: async (body, accessToken) => {
    try {
      const response = await axios.post(`${Url}/customer/switchprofile`, body, {
        headers: addWcdHeaders({
          "access-token": accessToken,
        }),
         withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },
   setCookie: async (token) => {
    //Accept user consent
    try {
       // eslint-disable-next-line
       let data ={token}
      const response = await axios.post(`${Url}/auth/set-cookie`, data);
      // const token = response.headers["x-access-token"];
      // sessionStorage.setItem(siteConstant.AUTH_TOKEN_STORAGE_KEY, token);
      return response;
    } catch (error) {
      console.log(error.message);
      return error
    }
  },
};
export default loginApiService;
